import { Box, Button, Text } from '@chakra-ui/react';
import Link from 'next/link';

const BookConsultation = () => {
  return (
    <Box
      bgImage={'/viewfinder-telescope.png'}
      bgPos="50% 75%"
      bgRepeat="no-repeat"
      bgSize="cover"
      display="flex"
      alignItems="center"
      justifyContent="center"
      h="270px"
      pos="relative"
    >
      <Box
        pos="absolute"
        top="0"
        left="0"
        w="100%"
        h="100%"
        bgColor="rgba(11, 19, 27, 0.3)"
      />
      <Box
        pos="relative"
        color="#ffffff"
        maxW="600px"
        mx="auto"
        textAlign="center"
      >
        <Text fontSize="1.6rem" className="technicalTop">
          You can make a briefing on anything you want. See how easy it is:
        </Text>

        <Link
          href="/contact?reason=Book%20a%20demo"
          style={{ textDecoration: 'none' }}
          target="_blank"
        >
          <Button
            size={'lg'}
            bg="#cf0032"
            color={'white'}
            _hover={{ bg: '#a90029' }}
            fontWeight={'bold'}
          >
            Book a consultation
          </Button>
        </Link>
      </Box>
    </Box>
  );
};

export default BookConsultation;
